import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticationService } from '../authentication/services/authentication.service';

export const increaseAccessGuard: CanActivateFn = () => {
  return (
    inject(AuthenticationService).getProfileState()?.featureFlagIncrease ===
      true || inject(Router).createUrlTree(['/wallet'])
  );
};
